import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

const rootElement = document.getElementById('root')

if (rootElement) {
  const root = createRoot(rootElement) // Criar o root
  root.render(
    <React.StrictMode>
      <DndProvider backend={HTML5Backend}>
        <App />
      </DndProvider>
    </React.StrictMode>,
  )
} else {
  console.error('Elemento root não encontrado')
}
